<script setup lang="ts">
import type { CmsElementBigTextBox } from "~/composables/useCustom";

const props = defineProps<{
  content: CmsElementBigTextBox;
}>();


const {image, imageMobile} = props.content?.config;

</script>
<template>
  <section v-if="image.value && imageMobile.value" class="section section-main section-about section-about--alt" :style="props.style" :class="props.class">
   <div class="container" >
    <img class="d-none d-lg-block" :src="image.value.url">
    <img class="d-block d-lg-none" :src="imageMobile.value.url">
   </div>
  </section>
</template>